import { DefaultContainedButton } from '@/components/buttons';
import { FormsActions, FormsSelector } from '@/store/forms';
import { Box, Stack, TextField, Typography, useTheme } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
export const ProfileForm = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const formId = 'userForm';
    const formValues = useSelector((state) => FormsSelector.getFormValues(state, formId));
    const { firstName = '', lastName = '', email = '' } = formValues;
    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(FormsActions.setValue({ id: 'steps', step: 1 }));
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        dispatch(FormsActions.setValue({ id: formId, [name]: value }));
    };
    return (React.createElement(Box, { my: 4, mx: "auto", width: "100%", px: 3, maxWidth: "880px" },
        React.createElement(Typography, { color: "secondary", fontSize: "1rem", fontWeight: 600 }, "About yourself"),
        React.createElement("form", { onSubmit: handleSubmit, autoComplete: "off" },
            React.createElement(Stack, { p: { sm: 4 }, my: 3, gap: 5, sx: { border: { sm: `1px solid ${theme.palette.grey[200]}` }, borderRadius: '8px' } },
                React.createElement(Box, null,
                    React.createElement(Box, { mb: 3 },
                        React.createElement(Typography, { mb: 0.5, fontSize: "14px", fontWeight: 500, color: "secondary.dark" }, "First name"),
                        React.createElement(TextField, { required: true, fullWidth: true, name: "firstName", value: firstName, variant: "outlined", onChange: handleChange, placeholder: "Eg. John", slotProps: {
                                input: {
                                    sx: { borderRadius: '6px' },
                                },
                            } })),
                    React.createElement(Box, { mb: 3 },
                        React.createElement(Typography, { mb: 0.5, fontSize: "14px", fontWeight: 500, color: "secondary.dark" }, "Last name"),
                        React.createElement(TextField, { required: true, fullWidth: true, name: "lastName", value: lastName, onChange: handleChange, variant: "outlined", placeholder: "Eg. Doe", slotProps: {
                                input: {
                                    sx: { borderRadius: '6px' },
                                },
                            } })),
                    React.createElement(Box, null,
                        React.createElement(Typography, { mb: 0.5, fontSize: "14px", fontWeight: 500, color: "secondary.dark" }, "Email address"),
                        React.createElement(TextField, { required: true, fullWidth: true, type: "email", name: "email", value: email, onChange: handleChange, variant: "outlined", placeholder: "Eg. john@example.com", slotProps: {
                                input: {
                                    sx: { borderRadius: '6px' },
                                },
                            } }))),
                React.createElement(Stack, { alignItems: "end" },
                    React.createElement(DefaultContainedButton, { type: "submit", title: "Continue", sx: { width: '180px' } }))))));
};
